import styled from "styled-components";
import { palette } from "../styles";


export const MainLoggin = styled.main`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  max-width: 100%;
  height: 100vh;
  .login-left {
    width: 100%;
  }
  .goback {
    width: 100px;
    height: 100px;
    border-radius: 100px;
    border: none;
    margin: 16px 64px 0 64px;
    box-shadow: 0 40px 112px -55px rgb(0 0 0 / 34%);
    position: absolute;
    right: 10px;
  }
  .login-right {
    padding: 24px;
    align-self: center;
    h3 {
      font-family: 'pieza-med', sans-serif;
      margin: 12px 0;
      font-size: 24px;
    }
    p {
      font-size: 16px;
      a {
        margin-left: 4px;
      }
    }
    img {
      width: 250px;
      display: table;
      margin: 0 auto 0 auto;
    }
    form {
      display: table;
      margin: 32px auto;
      width: 300px;
      input {
        box-sizing: border-box;
        color: #253858;
        background-color: #fff;
        border: 1px solid #d3d5d8;
        font-size: 1rem;
        padding: 10px;
        line-height: 1.7;
        border-radius: 4px;
        margin-bottom: 16px;
        width: 100%;
      }
      button[type='submit'] {
        width: 100%;
        background-color: ${palette.black};
        color: ${palette.white};
        font-size: 16px;
        margin-bottom: 12px;
        border-radius: 4px;
        border: none;
        padding: 10px 15px;
        cursor: pointer;
      }
    }
    .input-password {
      position: relative;
      svg {
        height: 1rem;
        position: absolute;
        right: 5%;
        top: 23%;
      }
    }
    .forgot-link {
      text-align: right !important;
      margin: 12px 0;
      background: none;
      border: none;
      cursor: pointer;
    }
    .text-center {
      text-align: center;
    }
  }
`;

export const ContainerMain = styled.main`
  .login {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    max-width: 100%;
    height: 100vh;
  }
  .text-center {
    text-align: center;
  }
  .login-left {
    width: 100%;
  }
  .login-right {
    padding: 24px;
    display: flex;
    flex-direction: column;
    justify-items: center;
    h3 {
      font-family: 'pieza-med', sans-serif;
      margin: 12px 0;
      font-size: 24px;
      text-align: center;
    }

    p {
      font-size: 16px;

      a {
        margin-left: 4px;
      }
    }

    img {
      width: 250px;
      display: table;
      margin: 20% auto 0 auto;
    }

    form {
      display: table;
      margin: 32px auto;
      width: 300px;
      input {
        box-sizing: border-box;
        color: #253858;
        background-color: #fff;
        border: 1px solid #d3d5d8;
        font-size: 1rem;
        padding: 10px;
        line-height: 1.7;
        border-radius: 4px;
        margin-bottom: 16px;
        width: 100%;
      }
      button {
        width: 100%;
        background-color: ${palette.black};
        color: ${palette.white};
        font-size: 16px;
        margin-bottom: 12px;
        border-radius: 4px;
        border: none;
        padding: 10px 15px;
        cursor: pointer;
      }
    }
  }
`;

export default null;